<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2>Your Lounges</h2>
    @if (isAdmin) {
    <div class="btn-group" role="group">
      <input type="radio" class="btn-check" name="filterMode" id="filterAll" [checked]="filterMode === 'all'"
        (change)="onFilterChange('all')">
      <label class="btn btn-outline-primary" for="filterAll">All Listings</label>
      <input type="radio" class="btn-check" name="filterMode" id="filterMine" [checked]="filterMode === 'mine'"
        (change)="onFilterChange('mine')">
      <label class="btn btn-outline-primary" for="filterMine">Created by Admin</label>
    </div>
    }
    <a class="btn btn-primary" routerLink="/pub">Create Pubs</a>
  </div>
  @if (loading) {
  <div class="text-center my-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  }
  @if (!loading && listings.length === 0) {
  <div class="alert alert-info text-center">
    <p class="mb-3">You have no lounges yet.</p>
    <a routerLink="/pub" class="btn btn-primary">
      <i class="fa-solid fa-plus me-2"></i>Create Your Lounge
    </a>
  </div>
  }
  @if (!loading && listings.length > 0) {
  <div class="row mt-4">
    @for (item of listings; track item) {
    <div class="col-md-4 mb-4">
      <div class="card shadow-sm h-100">
        <!-- Card Header -->
        <div class="card-header d-flex justify-content-between">
          <a class="cursor-pointer text-dark text-truncate text-decoration-none fw-bold d-block w-75"
            [href]="listingUrl(item.id)" target="_blank">
            {{ item.name }}
          </a>
          <div class="text-end">
            <!-- Tiny delete button -->
            <button class="btn btn-sm" (click)="openDialog(item)">
              <i class="fa-solid fa-xmark fa-lg" style="color: red"></i>
            </button>
            <!-- Tiny edit button -->
            <button class="btn btn-sm" (click)="editListing(item)">
              <i class="fa-solid fa-pen"></i>
            </button>
          </div>
        </div>
        <!-- Body -->
        <div class="card-body">
          @if (item.imageUrl) {
          <img [src]="item.imageUrl" class="img-fluid rounded mb-2 product-thumb" />
          }
          <p class="small text-muted">{{ item.summary }}</p>
          <div class="mt-2">
            <span class="badge bg-primary"> Entry Fee ₹ {{ item.listingPrice && item.listingPrice < item.price ?
                item.listingPrice : item.price }}</span>
                <span class="badge bg-info ms-2">{{ item.category }}</span>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
  <app-confirm-dialog [show]="showDialog" [title]="'Delete Listing'"
    [message]="'Are you sure you want to delete ' + selectedItem?.sku + '?'" [busy]="busy" [error]="confirmError"
    confirmText="Delete" cancelText="Cancel" (confirm)="handleConfirm()" (cancel)="handleCancel()"></app-confirm-dialog>
</div>